export function delayed(action: TimerHandler, timeout = 1) {
	window.setTimeout(action, timeout);
}
